// this is an autogenerated file from DesignSystem/SyncPatientMatchingCard/ReplacePatient/Content/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_SyncPatientMatchingCard_ReplacePatient_Content_Content_SearchResult($search_term: String!, $parent_company_id: uuid!) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: false
  ) {
    person: vaxiom_person {
      id
      first_name
      middle_name
      last_name
      gender
      birth_date
      # profile_pic_url
      patient {
        id
        _id
        # tx_cards(
        #   where: { deleted: { _eq: false } }
        #   order_by: { latest_appointment_booking_start_time: desc_nulls_last }
        # ) {
        #   txs(where: { deleted: { _eq: false } }) {
        #     is_active
        #     status
        #   }
        # }
      }
      contact_method_associations {
        id
        email {
          id
          address
        }
        phone {
          id
          number
        }
        postal_address {
          id
          zip
        }
      }
    }
  }
}

`